import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { EnvironmentService } from 'src/app/core/enviroment/environment.service';
import { GetNotificationsQuerys } from './notification.models';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private uri = this.environmentService.getEnvVar('api_home');

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
    ) {}

  getNotifications(query?: GetNotificationsQuerys) {
    let params = new HttpParams();
    for (const key in query) {
      if (query.hasOwnProperty(key)) {
        params = params.append(key, query[key]);
      }
    }
    params = params.append('rand', Math.random().toString());
    return this.http.get<any>(`${this.uri}/notifications-history`, {params});
  }

  getNextPageNotifications(link) {
    return this.http.get<any>(link);
  }

  readMessage(msg) {
    return this.http.patch<any>(`${this.uri}/notifications`, msg);
  }

  clearNotifications() {
    return this.http.post<any>(`${this.uri}/clear-all-notifications`, {});
  }

  checkNotificationPooling() {
    return this.http.get<any>(`${this.uri}/notifications-pooling?` + Math.random());
  }

  formatDate(date: Date, endOfDay: boolean) {
    const formatHour = endOfDay ? 'YYYY-MM-DD[T]23:59:ss.sss[Z]' : 'YYYY-MM-DD[T]00:00:ss.sss[Z]';
    return moment(date).format(formatHour);
  }
}
